import { useEffect, useState } from 'react';
import { API_BASE } from './config';

// =============================================================================
// '+ URL로 추가'(YouTube 등 웹 영상 다운로드) 버튼을 보일지 서버가 정한다.
//
// AWS 같은 데이터센터 IP에서는 YouTube가 봇 확인·로그인을 요구해 다운로드가 실패한다
// (yt-dlp 설치 여부와 별개). 관리자 번들은 AWS·사내(QA) 서버가 같으므로 번들에 박지 않고
// 서버의 /health.webVideoUrl(WEB_VIDEO_URL_ENABLED)을 한 번 읽어 따른다(2026-09-28).
// 값을 모르는 동안은 숨긴다 — 눌렀다가 실패하는 버튼보다 잠깐 늦게 나타나는 편이 낫다.
// 옛 서버처럼 값이 없거나 조회에 실패하면 예전대로 보인다.
// =============================================================================

let cached: Promise<boolean> | null = null;

export function readWebVideoUrlEnabled(): Promise<boolean> {
  cached ??= Promise.resolve().then(() => fetch(`${API_BASE}/health`, { cache: 'no-store' }))
    .then(response => response.ok ? response.json() as Promise<{ webVideoUrl?: unknown }> : {})
    .then(body => (body as { webVideoUrl?: unknown }).webVideoUrl !== false)
    .catch(() => true);
  return cached;
}

/** 테스트용 — 모듈 캐시를 비운다. */
export function resetWebVideoUrlCache(): void { cached = null; }

export function useWebVideoUrlEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    void readWebVideoUrlEnabled().then(value => { if (alive) setEnabled(value); });
    return () => { alive = false; };
  }, []);
  return enabled;
}
